import { createContext } from 'react';
import type { useListing } from './useListing';

export const ListingContext = createContext<ReturnType<typeof useListing>>(
  null as unknown as ReturnType<typeof useListing>,
);
